// ============================================================
// VISA REQUIREMENTS — CONSTANTS (code-level only)
// UI text, labels, colors, and content data are now managed
// through the admin CMS (Requiremnts editor).
// Only code-level config, functions, and enum maps remain here.
// ============================================================

export const ISO_TO_VISA_SLUG = {
  US: "usa",
  CA: "canada",
  GB: "uk",
  DE: "germany",
  FR: "france",
  IT: "italy",
  ES: "spain",
  CH: "switzerland",
  AU: "australia",
  NZ: "new-zealand",
  JP: "japan",
  SG: "singapore",
  TH: "thailand",
  ID: "indonesia",
  AE: "uae",
  VN: "vietnam",
  MV: "maldives",
  HK: "hong-kong",
  EG: "egypt",
  MY: "malaysia",
  TR: "turkey",
};

// Countries are now managed through the admin panel Requirements editor
// and stored in the tvc_content_sections / Google Sheets.
// No hardcoded country lists.

// ── Visa Types ────────────────────────────────────────────────
export const VISA_TYPES = {
  TOURIST: "tourist",
  BUSINESS: "business",
  STUDENT: "student",
  WORK: "work",
  TRANSIT: "transit",
};

// ── Visa Access Status ────────────────────────────────────────
export const VISA_STATUS = {
  VISA_FREE: "visa_free",
  VISA_ON_ARRIVAL: "visa_on_arrival",
  E_VISA: "e_visa",
  VISA_REQUIRED: "visa_required",
  NO_ENTRY: "no_entry",
};

// ── Document lucide-react icon names ────────────────────────
export const DOCUMENT_ICONS = {
  passport: "FileText",
  photo: "Camera",
  bankStatement: "CreditCard",
  itr: "Receipt",
  flightTicket: "Plane",
  hotelBooking: "Building2",
  insurance: "Shield",
  invitationLetter: "Mail",
  employmentLetter: "Briefcase",
  noc: "FileCheck",
  birthCertificate: "Baby",
  marriageCertificate: "Heart",
  sponsorLetter: "Users",
  coverLetter: "FileEdit",
  itin: "MapPin",
  visaFee: "DollarSign",
  biometrics: "Fingerprint",
  medicalCert: "Stethoscope",
  educationDocs: "GraduationCap",
};

// ── Processing speed classifier ──────────────────────────────
export const PROCESSING_SPEED_BANDS = {
  instant: { label: "Instant", color: "#10b981", bg: "#d1fae5" },
  fast: { label: "Fast", color: "#3b82f6", bg: "#dbeafe" },
  standard: { label: "Standard", color: "#f59e0b", bg: "#fef3c7" },
  slow: { label: "Slow", color: "#ef4444", bg: "#fee2e2" },
};

export const getProcessingSpeed = (processingTime) => {
  const t = (processingTime || "").toLowerCase();
  if (t.includes("instant") || t.includes("arrival") || t.includes("immediate")) return PROCESSING_SPEED_BANDS.instant;
  if (t.includes("72") || t.includes("24") || t.includes("3\u20137") || t.includes("1\u20134 days")) return PROCESSING_SPEED_BANDS.fast;
  if (t.includes("week") || t.includes("14") || t.includes("15")) return PROCESSING_SPEED_BANDS.standard;
  return PROCESSING_SPEED_BANDS.slow;
};

// ── Icon sizes used across components ────────────────────────
export const ICON_SIZES = {
  dropdownChevron: 16,
  dropdownClear: 13,
  dropdownSearchClear: 12,
  routeArrow: 18,
  searchArrow: 24,
};

// ── No-data section inline styles ────────────────────────────
export const NO_DATA_LABEL_STYLE = {
  fontSize: 12,
  color: "var(--clr-ink-faint)",
  marginBottom: 12,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.8px",
};

// ── Apply card inline style override ─────────────────────────
export const TIPS_CARD_HEADER_STYLE = { marginBottom: 0 };

// ── Processing Loader Config ─────────────────────────────────
export const LOADER_ANIMATION = { duration: 2400, interval: 30 };
